import { Option } from '@bbl-digital/snorre-v2'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BoardDocumentFilterSharedWithBblEnum } from 'shared/microServices/portalDocuments/models/BoardDocumentQueryModel'
import { RootState } from 'shared/store/store'

type Filter = {
  searchString?: string
  selectedTags?: Option[]
  documentType?: string
  fileType?: string
  currentPage?: number
  pageSize?: number
  startDate?: string
  endDate?: string
  sharedWithBbl?: BoardDocumentFilterSharedWithBblEnum
  isBoardTabActive?: boolean
}

const initialState: Filter = {
  searchString: '',
  selectedTags: [],
  documentType: '',
  fileType: '',
  currentPage: 1,
  pageSize: 10,
  startDate: '',
  endDate: '',
  sharedWithBbl: BoardDocumentFilterSharedWithBblEnum.Unfiltered,
  isBoardTabActive: true,
}

const boardArchiveSlice = createSlice({
  name: 'boardArchive',
  initialState,
  reducers: {
    resetBoardArchiveFilters: (state) => {
      state.searchString = initialState.searchString
      state.selectedTags = initialState.selectedTags
      state.sharedWithBbl = initialState.sharedWithBbl
      state.documentType = initialState.documentType
      state.fileType = initialState.fileType
      state.currentPage = initialState.currentPage
      state.startDate = initialState.startDate
      state.endDate = initialState.endDate
    },
    setBoardSearchString: (state, action: PayloadAction<string>) => {
      state.searchString = action.payload
    },
    setBoardSelectedTags: (state, action: PayloadAction<Option[]>) => {
      state.selectedTags = action.payload
    },
    setBoardSharedWithBbl: (
      state,
      action: PayloadAction<BoardDocumentFilterSharedWithBblEnum>
    ) => {
      state.sharedWithBbl = action.payload
    },
    setBoardDocumentType: (state, action: PayloadAction<string>) => {
      state.documentType = action.payload
    },
    setBoardFileType: (state, action: PayloadAction<string>) => {
      state.fileType = action.payload
    },
    setBoardCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload
    },
    setBoardPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload
    },
    setBoardFilter: (state, action: PayloadAction<Filter>) => {
      state.searchString = action.payload.searchString
      state.selectedTags = action.payload.selectedTags
      state.sharedWithBbl = action.payload.sharedWithBbl
      state.documentType = action.payload.documentType
      state.fileType = action.payload.fileType
      state.currentPage = action.payload.currentPage
      state.startDate = action.payload.startDate
      state.endDate = action.payload.endDate
    },
    setBoardIsBoardTabActive: (state, action: PayloadAction<boolean>) => {
      state.isBoardTabActive = action.payload
    },
  },
})

export const {
  resetBoardArchiveFilters,
  setBoardSearchString,
  setBoardSelectedTags,
  setBoardSharedWithBbl,
  setBoardDocumentType,
  setBoardFileType,
  setBoardCurrentPage,
  setBoardPageSize,
  setBoardFilter,
  setBoardIsBoardTabActive,
} = boardArchiveSlice.actions

export default boardArchiveSlice

export const getBoardArchiveFilters = (state: RootState) => state.boardArchive

export const getBoardArchiveIsBoardTabActive = (state: RootState) =>
  state.boardArchive.isBoardTabActive
